// extracted by mini-css-extract-plugin
module.exports = {"root":"_3jv_6","spotifyFrame":"_2quh9","rootInEditor":"_1Ihfs","rootInViewer":"_2xYhr"};